"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
const formatSpecialCharText = text => {
  if (text && typeof text === "string") {
    let formattedText = text?.split(/(™)|(©)|(®)/g);
    formattedText.forEach((character, i) => {
      if (character?.trim() === "™") {
        formattedText[i] = `<sup>&trade;</sup>`;
      }
      if (character?.trim() === "©") {
        formattedText[i] = `<sup>&copy;</sup>`;
      }
      if (character?.trim() === "®") {
        formattedText[i] = `<sup>&reg;</sup>`;
      }
    });
    formattedText = formattedText?.join("");
    return {
      __html: formattedText
    };
  }
  return null;
};
var _default = formatSpecialCharText;
exports.default = _default;